// import ApiService from '@/helpers/api.service';
import ApiService2 from '@/helpers/api.service.ext';

// const API = new ApiService();
const API2 = new ApiService2();
const KANTOADS_AUDIT_CANCELLATION_ENDPOINT = '/kantoads/audit-cancellation';
const KANTOADS_AUDIT_ENDPOINT = '/kantoads/audit';
const KANTOADS_CASHOUT_ENDPOINT = '/kantoads/cashout';
const KANTOADS_TOPUP_ENDPOINT = '/kantoads/topup';

export const state = {
    mcpTopupLogs: [],
    mcpTopupLogsPageInfo: {
        total: 0
    },
    mcpTopup: {},
    mcpTopupChangeLogs: [],
    mcpTopupChangeLogsPageInfo: {
        total: 0
    },
    errors: null,
    auditData: [],
    auditDataPage: {
      totalRows: 0,
      totalPage: 0
    },
    auditLogsData: [],
    auditLogsDataPage: {
      totalRows: 0,
      totalPage: 0,
      total: 0
    },
    mcpCashoutList: [],
    mcpCashoutPageInfo: {
        total: 0
    },
    mcpCashout: {},
    mcpCashoutChangeLogs: [],
    mcpCashoutChangeLogsPageInfo: {
        total: 0
    },
    cancellationList: [],
    cancellationListPageInfo: {
        total: 0
    },
    collateralOptions:[{ text: 'All', value: null }],
    cancellationRequestDetails:{},
    cancellationLogs: [],
    cancellationLogsPageInfo: {
        total: 0
    },
}

export const mutations = {
    UPDATE_MCP_TOPUP_LOGS(state, list){
        state.mcpTopupLogs = list;
    },
    UPDATE_MCP_PAGE_INFO(state, total){
        state.mcpTopupLogsPageInfo.total = total;
    },
    UPDATE_MCP_TOPUP(state, topup){
        state.mcpTopup = topup;
    },
    UPDATE_MCP_TOPUP_CHANGE_LOGS(state, list){
        state.mcpTopupChangeLogs = list;
    },
    UPDATE_MCP_CHANGE_LOGS_INFO(state, total){
        state.mcpTopupChangeLogsPageInfo.total = total;
    },
    SET_PROD_ERRORS(state, errors){
      state.errors = errors;
    },
    UPDATE_AUDIT_DATA_LIST(state, item){
        state.auditData = item;
    },
    UPDATE_AUDIT_DATA_PAGE(state, pageInfo){
        state.auditDataPage = pageInfo;
    },
    UPDATE_AUDIT_LOGS_DATA_LIST(state, item){
        state.auditLogsData = item;
    },
    UPDATE_AUDIT_LOGS_DATA_PAGE(state, pageInfo){
        state.auditLogsDataPage = pageInfo;
    },
    UPDATE_MCP_CASHOUTS(state, list){
        state.mcpCashoutList = list;
    },
    UPDATE_MCP_CASHOUT_PAGE_INFO(state, total){
        state.mcpCashoutPageInfo.total = total;
    },
    UPDATE_MCP_CASHOUT(state, cashout){
        state.mcpCashout = cashout;
    },
    UPDATE_MCP_CASHOUT_CHANGE_LOGS(state, list){
        state.mcpCashoutChangeLogs = list;
    },
    UPDATE_MCP_CASHOUT_CHANGE_LOGS_INFO(state, total){
        state.mcpCashoutChangeLogsPageInfo.total = total;
    },
    UPDATE_AUDIT_CANCELLATION_DATA_LIST(state, item){
        state.cancellationList = item;
    },
    UPDATE_AUDIT_CANCELLATION_DATA_PAGE(state, pageInfo){
        state.cancellationListPageInfo.total = pageInfo;
    },
    UPDATE_AUDIT_COLLATERAL_TYPES(state, item){
        state.collateralOptions = item;
    },
    UPDATE_AUDIT_CANCELLATION_REQUEST_DETAILS(state, item){
        state.cancellationRequestDetails = item;
    },
    UPDATE_AUDIT_CANCELLATION_LOGS(state, item){
        state.cancellationLogs = item;
    },
    UPDATE_AUDIT_CANCELLATION_LOGS_PAGE(state, pageInfo){
        state.cancellationLogsPageInfo.total = pageInfo;
    },
}

export const actions = {
    getMcpTopupLogs(context, params){
        return new Promise((resolve, reject) => {
          API2.post(`${KANTOADS_TOPUP_ENDPOINT}/get-kantoads-topups`, params)
            .then(({ data }) => {
              context.commit('UPDATE_MCP_TOPUP_LOGS', data.message.rows);
              context.commit('UPDATE_MCP_PAGE_INFO', data.message.pageInfo.total);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.message);
              reject();
            });
        });
    },

    getMcpTopup(context, params){
        return new Promise((resolve, reject) => {
          API2.post(`${KANTOADS_TOPUP_ENDPOINT}/get-topup-details`, params)
            .then(({ data }) => {
              context.commit('UPDATE_MCP_TOPUP', data.message.rows[0]);
              resolve();
            })
            .catch(({ response }) => {
              console.log("RESPONSE: ",response)  
              context.commit('SET_PROD_ERRORS', response.message);
              reject();
            });
        });
    },

    updateMcpTopup(context, params){
        return new Promise((resolve, reject) => {
          API2.post(`${KANTOADS_TOPUP_ENDPOINT}/update-topup`, params)
            .then(({ data }) => {
              resolve(data);
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.message);
              reject();
            });
        });
    },

    getTopupChangeLogs(context, params){
        return new Promise((resolve, reject) => {
          API2.post(`${KANTOADS_TOPUP_ENDPOINT}/get-topups-change-logs`, params)
            .then(({ data }) => {
              context.commit('UPDATE_MCP_TOPUP_CHANGE_LOGS', data.message.rows);
              context.commit('UPDATE_MCP_CHANGE_LOGS_INFO', data.message.pageInfo.total);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
              reject();
            });
        });
    },

    // REWARDS
    listAuditData(context, params){
        return new Promise((resolve, reject) => {
          API2.post(`${KANTOADS_AUDIT_ENDPOINT}/get-audit-all-data`, params)
            .then(({ data }) => {
              if(data.status == "err"){
                reject();
              } else {
                context.commit('UPDATE_AUDIT_DATA_LIST', data.message.rows);
                context.commit('UPDATE_AUDIT_DATA_PAGE', {
                    totalRows: data.message.pageInfo.total,
                    totalPage: data.message.pageInfo.noOfPage
                });
                resolve();
              }
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
              reject();
            });
        });
      },
      
      fetchAuditSingleData(context, auditId){
        console.log("AUDIT ID: ", auditId)
        return new Promise((resolve, reject) => {
          API2.post(`${KANTOADS_AUDIT_ENDPOINT}/get-audit-one-data`, {auditId: auditId})
            .then(({data}) => {
              if(data.status == "err"){
                reject(data.message);
              } else {
                resolve(data.message.rows);
              }
            })
            .catch(({response}) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
            })
        });
      },
      updateAuditData(context, params){
        return new Promise((resolve, reject) => {
          API2.post(`${KANTOADS_AUDIT_ENDPOINT}/update-audit-data`, params)
            .then(({data}) => {
              if(data.status == "err"){
                reject(data.message);
              } else {
                resolve(data);
              }
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
              reject();
            });
        });
      },

      fetchAuditLogsData(context, params){
        console.log("AUDIT ID: ", params)
        return new Promise((resolve, reject) => {
          API2.post(`${KANTOADS_AUDIT_ENDPOINT}/get-audit-logs-data`, params)
            .then(({data}) => {
              if(data.status == "err"){
                reject(data.message);
              } else {
                context.commit('UPDATE_AUDIT_LOGS_DATA_LIST', data.message.rows);
                context.commit('UPDATE_AUDIT_LOGS_DATA_PAGE', {
                    totalRows: data.message.pageInfo.total,
                    totalPage: data.message.pageInfo.noOfPage
                });
                resolve(data.message.rows);
              }
            })
            .catch(({response}) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
            })
        });
      },

    getMcpCashoutList(context, params){
        return new Promise((resolve, reject) => {
          API2.post(`${KANTOADS_CASHOUT_ENDPOINT}/get-cashouts`, params)
            .then(({ data }) => {
              context.commit('UPDATE_MCP_CASHOUTS', data.message.rows);
              context.commit('UPDATE_MCP_CASHOUT_PAGE_INFO', data.message.pageInfo.total);
              resolve();
            })
            .catch(({ response }) => {
              console.log("RESPONSE: ",response)  
              context.commit('SET_PROD_ERRORS', response.message);
              reject();
            });
        });
    },

    getMcpCashout(context, params){
        return new Promise((resolve, reject) => {
          API2.post(`${KANTOADS_CASHOUT_ENDPOINT}/get-cashout-details`, params)
            .then(({ data }) => {
              context.commit('UPDATE_MCP_CASHOUT', data.message.rows[0]);
              resolve();
            })
            .catch(({ response }) => {
              console.log("RESPONSE: ",response)  
              context.commit('SET_PROD_ERRORS', response.message);
              reject();
            });
        });
    },

    updateMcpCashout(context, params){
        return new Promise((resolve, reject) => {
          API2.post(`${KANTOADS_CASHOUT_ENDPOINT}/update-cashout`, params)
            .then(({ data }) => {
              resolve(data);
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.message);
              reject();
            });
        });
    },

    getCashoutChangeLogs(context, params){
        return new Promise((resolve, reject) => {
          API2.post(`${KANTOADS_CASHOUT_ENDPOINT}/get-cashout-change-logs`, params)
            .then(({ data }) => {
              context.commit('UPDATE_MCP_CASHOUT_CHANGE_LOGS', data.message.rows);
              context.commit('UPDATE_MCP_CASHOUT_CHANGE_LOGS_INFO', data.message.pageInfo.total);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
              reject();
            });
        });
    },

    auditCancellationRequestList(context, params){
      return new Promise((resolve, reject) => {
        API2.post(`${KANTOADS_AUDIT_CANCELLATION_ENDPOINT}/list`, params)
          .then(({ data }) => {
            if(data.status == "err"){
              reject();
            } else {
              context.commit('UPDATE_AUDIT_CANCELLATION_DATA_LIST', data.message.rows);
              context.commit('UPDATE_AUDIT_CANCELLATION_DATA_PAGE', data.message.pageInfo.total);
              resolve();
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    auditCollateralType(context, params){
      return new Promise((resolve, reject) => {
        API2.post(`${KANTOADS_AUDIT_CANCELLATION_ENDPOINT}/collateral-type`, params)
          .then(({ data }) => {
            if(data.status == "err"){
              reject();
            } else {
              context.commit('UPDATE_AUDIT_COLLATERAL_TYPES', data.message);
              resolve();
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    fetchAuditCancallationRequest(context, id){
      return new Promise((resolve, reject) => {
        API2.post(`${KANTOADS_AUDIT_CANCELLATION_ENDPOINT}/cancellation-request`, {"cancellationRequestId": id})
          .then(({ data }) => {
            if(data.status == "err"){
              reject();
            } else {
              context.commit('UPDATE_AUDIT_CANCELLATION_REQUEST_DETAILS', data.message);
              resolve();
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    formAuditCancallationRequest(context, params){
      return new Promise((resolve, reject) => {
        API2.post(`${KANTOADS_AUDIT_CANCELLATION_ENDPOINT}/update-cancellation-request`, params)
          .then(({ data }) => {
            if(data.status == "err"){
              reject();
            } else {
              // context.commit('UPDATE_AUDIT_CANCELLATION_REQUEST_DETAILS', data.message);
              resolve();
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    auditCancellationRequestLogs(context, params){
      return new Promise((resolve, reject) => {
        API2.post(`${KANTOADS_AUDIT_CANCELLATION_ENDPOINT}/cancellation-request-logs`, params)
          .then(({ data }) => {
            if(data.status == "err"){
              reject();
            } else {
              context.commit('UPDATE_AUDIT_CANCELLATION_LOGS', data.message.rows);
              context.commit('UPDATE_AUDIT_CANCELLATION_LOGS_PAGE', data.message.pageInfo.total);
              resolve();
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
}